import React from "react";
import PropTypes from "prop-types";

class ConfirmUpdateTips extends React.Component {
  render() {
    const { text, className } = this.props;
    return (
      <div
        className={`confirm-update-tips-container ${className || ""}`}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }
}

ConfirmUpdateTips.propTypes = {
  text: PropTypes.string,
};

export default ConfirmUpdateTips;
